import { defineStore } from 'pinia';

export const useNotificationStore = defineStore('notification', {
  state: () => {
    return {
      unreadNotifications: 0,
    };
  },
  actions: {
    setUnreadNotifications(count) {
      this.unreadNotifications = count;
    },
  },
});
